import { useEffect, useState } from "react";
import moment from "moment";
import { useDispatch, useSelector } from "react-redux"
import { Spinner } from "../../components/Loading";
import { ContentListScreen } from "../../screen/ContentListScreen"
import { useScope } from "../SelectProjectCompanyContainer";
import Send from "../../core/communication";
import { useNavigate } from "react-router-dom";
import { setData } from "../../core/redux/app/Actions";
import { useForm } from "react-hook-form";
import { IoFilterOutline } from "react-icons/io5";
import { FilterModal } from "../../screen/DashboardScreen";
import { useDWOptions } from "../../core/utils/hooks/useDwOptions";

const SubHeaderFilterTable = ({
  setIsOpen,
  isOpen,
  onChange,
  loading,
  dw,
  values,
  control,
  onSearch,
}) => {
  return (
    <>
      <div class="div-btn-filter">
        <div class="icon-container" onClick={() => setIsOpen(true)}>
          <IoFilterOutline className="icon-filter" />
          <text class="text-filter">Filtrar</text>
        </div>
      </div>
      <FilterModal
        {...{
          modalIsOpen: isOpen,
          setModalIsOpen: setIsOpen,
          onChange,
          loading,
          dw,
          values,
          journey: false,
          useQuestions: false,
          control,
          onSearch,
          period: true,
          type: 'year',
          useForms: false
        }}
      />
    </>
  )
}

const ContentListContainer = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate();
  const dataFilter = useSelector(state => state.app?.filter);
  const contentDetails = useSelector(state => state.app?.contentList);
  const { scope } = useScope();
  const [dw, reload] = useDWOptions();
  const [loading, setLoading] = useState(false);
  const [columns, setColumns] = useState([]);
  const [values, setValues] = useState({});
  const [isOpen, setIsOpen] = useState(false);
  const [dataTable, setDataTable] = useState([]);

  const { control, setValue } = useForm({
    mode: "onBlur",
  })

  useEffect(() => {
    loadData(dataFilter?.projects || [], dataFilter?.year);
  }, [dataFilter])
  
  useEffect(() => {
    if(contentDetails) {
      setDataTable(transformDataToTable());
    }
  }, [contentDetails])

  const loadData = async (projects, year) => {
    if(!contentDetails) setLoading(true);

    let extraQueries = '';
    let newProjects = projects || [];

    if(!Array.isArray(newProjects) || !newProjects.length) newProjects = [{value: scope?.id}];

    newProjects = newProjects
      .filter(item => item?.value)
      .map(project => project.label !== 'Ambev' ? `'${project?.value}'` : project?.value).toString();

    if(year) {
      extraQueries += `&year=${year}`;
    }

    if(values?.farmers && values.farmers.length) {
      const farmers = values.farmers.filter(f => f && f.value).map(f => `'${f.value}'`).toString();
      extraQueries += `&users=${farmers}`
    }

    const details = await Send.get("/DW/content/details", `projects=${newProjects}${extraQueries}`);
    dispatch(setData({ contentList: details }));
    setLoading(false); 
  }

  const onChange = (field) => {
    return (value) => {
      setValues((values) => ({ ...values, [field]: value }))
    }
  }

  const onSearch = () => {
    loadData(values?.projects || [], values?.year);
    setIsOpen(false)
  }

  const transformDataToTable = () => {
    const newColumns = [
      { title: "Produtor", code: "Produtor" },
      { title: "Tecnico", code: "Tecnico" },
      { title: "Data do Envio", code: "DataEnvio" },
      { title: "Data da Leitura", code: "DataLeitura" },
      { title: "Conteúdo", code: "Titulo" },
      { title: "Link", code: "Link" },
    ];

    setColumns(newColumns);

    return {
      codes: newColumns,
      fields: Array.isArray(contentDetails) && contentDetails.map((item) => ({
        ...item,
        DataEnvio: moment(item.DataEnvio).format("DD/MM/YYYY"),
        DataLeitura: moment(item.DataLeitura).format("DD/MM/YYYY"),
      })) || [],
      columns: ["Produtor", "Tecnico", "DataEnvio", "DataLeitura", "Titulo", "Link"],
    }
  }

  const onFilter = (values) => {
    const newContentDetails = { dataTable, columns, currentContent: values };
    dispatch(setData({ contentDetails: newContentDetails }));
    navigate(`/details/content/${values?.userId}/${values?.muralId}`);
  }

  return <>
    {loading ?
      <div className="loading-content"><Spinner color="primary"/></div> :
      <div>
        <SubHeaderFilterTable
          {...{
            setIsOpen,
            isOpen,
            dw: { ...dw, ...dataFilter},
            onChange,
            values,
            control,
            onSearch,
          }}
        />
        <ContentListScreen
          dataTable={dataTable}
          onFilter={onFilter}
        />
      </div>
    }
  </>
}

export default ContentListContainer